import { supabase, isSupabaseConfigured } from './supabase'
import { logger } from './logger'

const log = logger('ClipboardCheckout')

export function requestExtensionRedeem(payload: { sessionId?: string; restoreToken?: string }) {
  window.postMessage(
    {
      type: 'YELLOW_PAD_REDEEM',
      sessionId: payload.sessionId ?? null,
      restoreToken: payload.restoreToken ?? null,
    },
    window.location.origin
  )
}

export async function redirectToClipboardCheckout(): Promise<void> {
  if (!isSupabaseConfigured) {
    throw new Error('Payments are not configured')
  }

  const { data, error } = await supabase.functions.invoke('create-clipboard-checkout', {
    body: { appUrl: window.location.origin },
  })

  if (error) {
    log.error('Failed to create clipboard checkout:', error)
    throw new Error('Could not start checkout. Try again.')
  }

  if (data?.error) {
    throw new Error(data.error)
  }

  if (!data?.url) {
    throw new Error('No checkout URL returned')
  }

  window.location.href = data.url
}

export async function verifyClipboardCheckout(sessionId: string) {
  const { data, error } = await supabase.functions.invoke('verify-clipboard-checkout', {
    body: { sessionId },
  })

  if (error || data?.error) {
    throw new Error(data?.error || 'Could not verify payment')
  }

  return data as { paid: boolean; status: string; email: string | null; sessionId: string }
}

export async function requestClipboardRestore(email: string) {
  const { data, error } = await supabase.functions.invoke('request-clipboard-restore', {
    body: { email, appUrl: window.location.origin },
  })

  if (error) {
    log.error('Failed to request clipboard restore:', error)
    throw new Error('Could not send a restore link. Try again.')
  }

  return data as { ok: boolean; emailed?: boolean }
}
